import React from 'react'

import { Col, Row, Button } from '_zari/core'

import FilaTemplate from './filaTemplate'

const SustraccionesSection = ({
  setSustraccionesAplicadas,
  sustraccionesAplicadas,
  montoBase,
  recalcularMontoTotal
}) => {
  const actualizarFilaHandler = React.useCallback(
    ({ index, rowData }) => {
      setSustraccionesAplicadas(prev => {
        const salida = [...prev]

        const matchIndex = salida.findIndex(x => x.index === index)
        salida[matchIndex] = rowData

        recalcularMontoTotal(salida)

        return salida
      })
    },
    [setSustraccionesAplicadas, recalcularMontoTotal]
  )

  const clickAgregarSustraccion = React.useCallback(() => {
    setSustraccionesAplicadas(prev => {
      const salida = [...prev]

      salida.push({
        index: salida.length,
        porcentaje: '',
        tipo: '',
        monto: ''
      })

      return salida
    })
  }, [setSustraccionesAplicadas])

  const clickEliminarSustraccion = React.useCallback(
    ({ index }) => {
      setSustraccionesAplicadas(prev => {
        const salida = [...prev].filter(x => x.index !== index)

        recalcularMontoTotal(salida)
        return salida
      })
    },
    [setSustraccionesAplicadas, recalcularMontoTotal]
  )

  const tableBody = React.useMemo(() => {
    const salida = []

    for (let i = 0; i < sustraccionesAplicadas.length; i++) {
      let defaultData = sustraccionesAplicadas[i]

      salida.push(
        <FilaTemplate
          index={i}
          key={i}
          defaultData={defaultData || {}}
          actualizarFilaHandler={actualizarFilaHandler}
          flagUltimo={i === sustraccionesAplicadas.length - 1}
          montoBase={montoBase}
          clickEliminarSustraccion={clickEliminarSustraccion}
        />
      )
    }

    return salida
  }, [sustraccionesAplicadas, actualizarFilaHandler, montoBase, clickEliminarSustraccion])

  return (
    <>
      <Row className='mt-2 mb-1'>
        <Col md={12}>
          <table width='100%'>
            <thead>
              <tr>
                <th>Tipo</th>
                <th>Porcentaje</th>
                <th>Monto</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {tableBody}
              <tr>
                <td colSpan={4}>
                  <Button id='boton-sustraccion-agregar-fila' onClick={clickAgregarSustraccion} outline block>
                    Agregar retencion
                  </Button>
                </td>
              </tr>
            </tbody>
          </table>
        </Col>
      </Row>
    </>
  )
}

export default React.memo(SustraccionesSection)
